import L from 'leaflet'

export function getBoundsFromPoints(points: [number, number][]): L.LatLngBounds | null {
  if (points.length === 0) return null
  return L.latLngBounds(points)
}
